@if (editContacts$ | async) {
  <div class="fab">
    <button mat-fab color="accent" (click)="click()">
      <app-icon icon="address-card"></app-icon>
    </button>
  </div>
}
